import { useMutation } from "@tanstack/react-query";
import { getDisciplineSubjects } from "../../queries/SelectSubjectSchedule";

type TRequestBody = {
  cronogramaId: string;
  disciplina: string;
}

const useGetDisciplineSubjects = () => {
  const { mutate, data, error, isPending, isError } = useMutation({
    mutationKey: ['get-discipline-subjects-by-subarea'],
    mutationFn: async ({ cronogramaId, disciplina }: TRequestBody) => getDisciplineSubjects(cronogramaId, disciplina),
    retry: false
  });

  return { mutate, data, error, isPending, isError };
};

export default useGetDisciplineSubjects;